import React, { useState, useEffect, useRef } from "react";

import { store } from "react-notifications-component";

import api from "../../../services/api";
import estados from "../../../services/estados";
import { hasReceitaSolicitada } from "../../../services/receitaSolicitada";

import { Container } from "react-grid-system";

import Relation from './relation';
import Select from "../../select/select_v2";
import SelectV2StepOne from "../../select/select_v2_step_one";
import Modal from '../../modal/modalGeneric';

import CheckGreenIcon from "../../../assets/icons/icon-check-green.svg";
import PlusBlueIcon from "../../../assets/icons/icon-plus-blue.png";
import PlusGrayIcon from "../../../assets/icons/totvs/icon-plus-gray.png";
import ArrowIcon from "../../../assets/icons/icon-arrow-down-circle-gray.png";
import cancelaIcon from "../../../assets/icons/icon-trash-red.png";

import * as S from "./styles"
import { theme } from "../../../styles/theme";
import { TaglineG, TaglineMSpan, TaglinePSpan } from "../../../styles/stylesTypography";
import { FormContainer, Card, RowCard, Row, ContainerRelationOptions, Dispensed } from "./styles";
import { set } from "date-fns";

import Estados from "../../../services/estados";
import { isTotvs } from "../../../services/globalFunctions";

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import { Loading } from '../../loading/styles';
import PragaDossieDrawer from "../../praga-dossie-drawer";
import { openCulturaUrl } from "../../../utils/culturasPdf";

const PrescriptionStepOne = ({ ...props }) => {
    const { updateQuantidadeRelations, compendioParams, startValidation } = props;
    const showIncompleteRelationAlertOnProceedOnly = props?.showIncompleteRelationAlertOnProceedOnly === true;
    const showIncompleteRelationAlertOnlyOnce = props?.showIncompleteRelationAlertOnlyOnce === true;

    const [disabledEstado, setDisabledEstado] = useState(false);
    const [disabledCultura, setDisabledCultura] = useState(false);
    const [disabledPraga, setDisabledPraga] = useState(false);
    const [disabledProduto, setDisabledProduto] = useState(false);

    //values
    const [estadoId, setEstado] = useState('');
    const [culturaId, setCulturaId] = useState("");
    const [pragasId, setPragasId] = useState([]);
    const [produtosId, setProdutosId] = useState([]);
    const [produtosLabel, setProdutosLabel] = useState([]);

    //options select
    const [culturas, setCulturas] = useState("");
    const [pragas, setPragas] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [state, setState] = useState(estados);
    const [estadosParaSelecionar, setEstadosParaSelecionar] = useState(state)


    const [relations, setRelations] = useState([0]);
    const [openRelation, setOpenRelation] = useState([false]);
    const [maxRelations, setMaxRelations] = useState(1);
    const [isLoadingRelations, setIsLoadongRelations] = useState(false);

    const [relationsInfoArray, setRelationsInfoArray] = useState([]);

    const [loading, setLoading] = useState(false);
    const [saveDate, setSaveDate] = useState('');
    const [isErroNotRelation, setIsErroNotRelation] = useState(false);
    const [closeAll, setCloseAll] = useState(false);
    const [showModalHelp, setShowModalHelp] = useState(false);
    const [existDispensedProduct, setExistDispensedProduct] = useState(false);
    const [dispensedIndex, setDispensedIndex] = useState('');
    const [loadingCompendio, setLoadingCompendio] = useState(true);

    const [isCompendio, setIsCompendio] = useState(false);
    const [dossieOpen, setDossieOpen] = useState(false);
    const [dossie, setDossie] = useState({ id: null, name: "" });

    const [boxOpen, setBoxOpen] = useState(false);
    const [loadingRelationAt, setLoadingRelationAt] = useState({});
    const compendioVersion = useRef({});

    const setRelationLoading = (index, value) =>
        setLoadingRelationAt(prev => ({ ...prev, [index]: value }));
    // Culturas comuns a TODOS os produtos do rascunho (null = sem restrição)
    const culturasIntersecaoRef = useRef(null);
    const receitaSolicitadaFirstFetchDoneRef = useRef(false);

    // Evita reexecutar o preenchimento de rascunho múltiplas vezes
    const prefillOnce = useRef({ estado: false, cultura: false, produto: false, praga: false, multi: false });
    const hasShownIncompleteRelationAlertRef = useRef(false);
    const culturaSetByCompendio = useRef(false);
    const hasRecipeDraft = !!(props?.recipeDraft && Object.keys(props.recipeDraft).length > 0);
    const draftLocksCultura = hasRecipeDraft && !!props?.recipeDraft?.cultura_id;

    const getDraftRelationOrder = (idx) => {
        const orders = Array.isArray(props?.recipeDraft?.agro_prescriptions_relations_orders)
            ? props.recipeDraft.agro_prescriptions_relations_orders
            : [];
        return orders[idx] || null;
    };

    const getDraftPestId = (idx) => {
        const order = getDraftRelationOrder(idx);
        const id = order?.pest_id ?? order?.agro_pest_id ?? props?.recipeDraft?.agro_pest_id;
        if (id == null || id === '') return null;
        const parsed = Number(id);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const resolvePestIdFromOptions = (pragasFormat, index, pragaParam) => {
        const pestFromParam = pragaParam && pragaParam !== '*' ? Number(pragaParam) : null;
        const draftPestId = getDraftPestId(index);
        const candidate = pestFromParam || draftPestId;
        if (candidate) {
            const found = (pragasFormat || []).find((p) => Number(p.value) === Number(candidate));
            if (found) return found.value;
        }
        if (Array.isArray(pragasFormat) && pragasFormat.length === 1) {
            return pragasFormat[0].value;
        }
        return '';
    };

    const isRelationComplete = (idx) => {
        if (existDispensedProduct && dispensedIndex === idx) return true;
        const info = relationsInfoArray[idx];
        if (!info) return false;
        if (relations[idx] === 0) return false;
        if (info.isException) {
            if (!info.fase || (Array.isArray(info.fase) && info.fase.length === 0)) return false;
        }
        // modalidadeAplicacao pode ser objeto {value,label} (preenchido) OU array vazio []
        // (estado inicial padrão em relation.js, useState([])) - []  é TRUTHY em JS, então
        // "!!info.modalidadeAplicacao" sempre dava true mesmo sem nada selecionado. Precisa
        // checar o .value de verdade, não só se a variável existe.
        const hasModalidade = !!(info.modalidadeAplicacao && info.modalidadeAplicacao.value);
        const hasDose = !!info.dose;
        const hasNum = !!info.numeroAplicacoes;
        const hasArea = !!info.areaTratar;
        const hasQtd = !!info.quantidadeAdquirir;
        return hasModalidade && hasDose && hasNum && hasArea && hasQtd;
    };

    const isRelationInvalid = (idx) => {
        if (existDispensedProduct && dispensedIndex === idx) return false;
        const info = relationsInfoArray[idx];
        if (!info) return false;
        if (info.isException && (!info.fase || (Array.isArray(info.fase) && info.fase.length === 0))) return true;
        if (!(info.modalidadeAplicacao && info.modalidadeAplicacao.value)) return true;
        if (!info.dose) return true;
        if (!info.numeroAplicacoes) return true;
        if (!info.areaTratar) return true;
        if (!info.quantidadeAdquirir) return true;
        return false;
    };

    const isLocked = (index) => hasRecipeDraft && index > 0 && !isRelationComplete(index - 1);

    const getProductIdForIndex = (idx) => {
        const rawId = Array.isArray(produtosId) ? produtosId[idx] : undefined;
        const id = (rawId && typeof rawId === 'object') ? rawId.value : rawId;
        if (id && id !== '') return id;
        const orders = Array.isArray(props?.recipeDraft?.agro_prescriptions_relations_orders) ? props.recipeDraft.agro_prescriptions_relations_orders : [];
        const draftId = orders[idx]?.agro_product_id;
        return draftId || id || '*';
    };

    const getPestIdForIndex = (idx) => {
        const value = Array.isArray(pragasId) ? pragasId[idx] : undefined;
        const normalized = (value && typeof value === "object") ? value.value : value;
        if (normalized && normalized !== '') return normalized;
        const comp = Array.isArray(compendioParams) ? compendioParams[idx] : null;
        if (comp?.praga) return comp.praga;
        const draftId = getDraftPestId(idx);
        return draftId || normalized || '';
    };

    const getCulturaValue = () => {
        const selected = culturaId && culturaId.value ? culturaId.value : '';
        if (selected) return selected;
        const comp = Array.isArray(compendioParams) ? compendioParams[0] : null;
        if (comp?.cultura) return comp.cultura;
        return props?.recipeDraft?.cultura_id || '';
    };

    const getEstadoValue = () => {
        const selected = estadoId && estadoId.value ? estadoId.value : '';
        if (selected) return selected;
        const comp = Array.isArray(compendioParams) ? compendioParams[0] : null;
        if (comp?.estado) return comp.estado;
        return props?.recipeDraft?.local_aplicacao_estado || '';
    };

    const firstIncompleteIndex = () => {
        if (!hasRecipeDraft) return -1;
        for (let i = 0; i < relations.length; i++) {
            if (!isRelationComplete(i)) return i;
        }
        return -1;
    };

    const formatCulturas = culturas => {
        culturas = culturas.map(cultura => {
            const hasScientific = cultura && cultura.nome_cientifico && String(cultura.nome_cientifico).trim() !== '';
            const format = {
                value: cultura.id,
                label: cultura.nome_comum,
                // Use label for UI, and searchLabel for Google search (Foto)
                searchLabel: hasScientific
                    ? `${cultura.nome_comum} - ${cultura.nome_cientifico}`
                    : cultura.nome_comum,
            };
            return format;
        });
        return culturas;
    };

    const formatPragas = pragas => {
        pragas = pragas.map(praga => {
            const format = {
                value: praga.id,
                label: `${praga.nome_comum} - ${praga.nome_cientifico}`,
                nome_cientifico: praga.nome_cientifico,
                searchTerms: [praga.nome_comum, praga.nome_cientifico, ...(praga.nomes_vulgares || [])]
            };
            return format;
        });
        return pragas;
    };

    const formatProdutos = produtos => {
        produtos = produtos.map(produto => {
            const format = {
                value: produto.id,
                label: `${produto.nome_comercial} - ${produto.fabricante}`,
                dispensado: produto.receituario_dispensado,
                searchTerms: [produto.nome_comercial, produto.nome_tecnico, produto.fabricante, ...(produto.principios_ativos || [])]
            };

            return format;
        });

        return produtos;
    };

    const getCulturas = async () => {
        try {
            setCulturas([]);
            setDisabledCultura(true);

            const response = await api.get(`/culturas`);
            let culturas = response.data.data;
            setTimeout(() => {
                if (culturaSetByCompendio.current) return;
                culturas = formatCulturas(culturas);
                setCulturas(culturas);
                setDisabledCultura(false);
            }, 200);

        } catch (error) {

        }
    };

    useEffect(() => {
        // console.log("draft", props?.recipeDraft)
        const draft = props?.recipeDraft;
        if (!draft || Object.keys(draft).length === 0) return;

            // ESTADO 
            if (!prefillOnce.current.estado && draft.local_aplicacao_estado) {
                const uf = draft.local_aplicacao_estado;
                const currentUf = estadoId?.value;
                if (!currentUf || currentUf !== uf) {
                    const estadoOption = Estados.find(e => e.value === uf) || { value: uf, label: uf };
                    changeEstado(estadoOption);
                }
                prefillOnce.current.estado = true;
            }

            // Multi-prefill (orders do rascunho) - roda antes do gate culturasLoaded
            // para disparar searchCompendio(produto) antes do setTimeout de getCulturas()
            const orders = Array.isArray(draft.agro_prescriptions_relations_orders) ? draft.agro_prescriptions_relations_orders : [];
            const culturaReady = !draft.cultura_id || !!culturaId;
            const canPrefillFromOrders = estadoId && culturaReady && orders.length > 0 && !prefillOnce.current.multi;
            if (canPrefillFromOrders) {
                const targetCount = orders.length;
                const currentLen = relations.length;
                const nextRelations = [...relations];
                const nextOpen = [...openRelation];
                const nextInfos = [...relationsInfoArray];
                const nextProdutos = Array.isArray(produtos) ? [...produtos] : [];
                const nextPragas = Array.isArray(pragas) ? [...pragas] : [];
                const nextIds = Array.isArray(produtosId) ? [...produtosId] : [];
                const nextLabels = Array.isArray(produtosLabel) ? [...produtosLabel] : [];
                const nextPragasId = Array.isArray(pragasId) ? [...pragasId] : [];
                if (currentLen < targetCount) {
                    for (let i = currentLen; i < targetCount; i++) {
                        nextRelations.push(0);
                        nextOpen.push(false);
                        nextInfos.push({});
                        nextProdutos[i] = nextProdutos[i] || [];
                        nextPragas[i] = nextPragas[i] || [];
                    }
                }

                // Pré-popula opções e valores para todos os índices com base no draft.
                // Isso evita efeitos colaterais de mudanças em cascata e garante 1 produto por input.
                for (let i = 0; i < targetCount; i++) {
                    const item = orders[i];
                    if (item) {
                        const id = item.agro_product_id;
                        const name = item.nome_comercial;
                        const manuf = item.fabricante;
                        const label = name && manuf ? `${name} - ${manuf}` : (name || '');
                        nextProdutos[i] = [{ value: id, label }];
                        nextIds[i] = id;
                        nextLabels[i] = label;
                        const pestId = getDraftPestId(i);
                        if (pestId) {
                            nextPragasId[i] = pestId;
                        }
                    }
                }

                setRelations(nextRelations);
                setOpenRelation(nextOpen);
                setRelationsInfoArray(nextInfos);
                setProdutos(nextProdutos);
                setPragas(nextPragas);
                setProdutosId(nextIds);
                setProdutosLabel(nextLabels);
                setPragasId(nextPragasId);
                prefillOnce.current.produto = true;
                prefillOnce.current.multi = true;
                if (nextPragasId.some((id) => id)) {
                    prefillOnce.current.praga = true;
                }
                if (targetCount > 0) {
                    const firstProductId = nextIds[0] || '*';
                    searchCompendio(firstProductId, culturaId?.value || '*', '*', estadoId.value, 0, { bypassReceitaSolicitadaGuard: true });
                    // Demais relações: carrega as pragas de cada produto para resolver a praga vinda do rascunho
                    if (culturaId?.value) {
                        for (let i = 1; i < targetCount; i++) {
                            const productId = nextIds[i] || '*';
                            searchCompendio(productId, culturaId.value, '*', estadoId.value, i, { forceReceitaSolicitadaCompendio: true });
                        }
                    }
                }
                // Para múltiplos produtos: busca compêndio de cada um e aplica interseção de culturas
                if (targetCount > 1) {
                    const idsValidos = nextIds.filter(id => id && id !== '*');
                    if (idsValidos.length > 1) {
                        const cultEstado = estadoId.value;
                        // cultura sempre '*': queremos TODAS as culturas que cada produto suporta no estado
                        // Marca que culturas serão definidas pela interseção — bloqueia getCulturas()
                        culturaSetByCompendio.current = true;
                        Promise.all(
                            idsValidos.map(pid => api.get(`/compendio/${pid}/*/*/${cultEstado}`))
                        ).then(results => {
                            const allCults = results.map(r => formatCulturas(r?.data?.data?.culturas || []));
                            if (allCults.length === 0 || allCults[0].length === 0) return;
                            const intersecao = allCults.reduce(
                                (acc, cults) => acc.filter(c => cults.some(cp => cp.value === c.value)),
                                [...allCults[0]]
                            );
                            // Persiste para que qualquer searchCompendio posterior respeite a interseção
                            culturasIntersecaoRef.current = intersecao;
                            setCulturas([""]);
                            setCulturas(intersecao);
                        }).catch(() => {});
                    }
                }
            }

            //CULTURA
            const culturasLoaded = Array.isArray(culturas) && culturas.length > 0;
            if (!culturasLoaded) return;

            if (!prefillOnce.current.cultura && draft.cultura_id) {
                const currentCultura = culturaId?.value;
                if (!currentCultura || currentCultura !== draft.cultura_id) {
                    const culturaOption = culturas.find(c => c.value === draft.cultura_id) || {
                        value: draft.cultura_id,
                        label: draft.cultura_nome_comum || ''
                    };
                    changeCultura(culturaOption);
                }
                prefillOnce.current.cultura = true;
            }

            // Prefill Produto (relation 0) - apenas quando não há orders (caso sem agro_prescriptions_relations_orders)
            const produtosLoaded = Array.isArray(produtos) && produtos[0] && produtos[0].length > 0;
            const hasDraftOrders = orders.length > 0;
            if (produtosLoaded && !prefillOnce.current.produto && !hasDraftOrders) {
                const draftProductId = draft.agro_product_id || (draft.agro_prescriptions_relations_orders && draft.agro_prescriptions_relations_orders[0] && draft.agro_prescriptions_relations_orders[0].agro_product_id);
                const draftProductName = draft.nome_comercial || (draft.agro_prescriptions_relations_orders && draft.agro_prescriptions_relations_orders[0] && draft.agro_prescriptions_relations_orders[0].nome_comercial);
                const draftManufacturer = draft.fabricante || (draft.agro_prescriptions_relations_orders && draft.agro_prescriptions_relations_orders[0] && draft.agro_prescriptions_relations_orders[0].fabricante);

                let productOption = null;
                if (draftProductId) {
                    productOption = produtos[0].find(p => p.value === draftProductId);
                }
                if (!productOption && draftProductName && draftManufacturer) {
                    const fullLabel = `${draftProductName} - ${draftManufacturer}`.toLowerCase();
                    productOption = produtos[0].find(p => (p.label || '').toLowerCase() === fullLabel);
                }
                if (!productOption && draftProductName) {
                    const nameLower = draftProductName.toLowerCase();
                    productOption = produtos[0].find(p => (p.label || '').toLowerCase().startsWith(nameLower));
                }

                if (productOption) {
                    changeProductOnRelation(productOption, 0);
                    prefillOnce.current.produto = true;
                }
            }

            // Prefill Praga/Alvo (relation 0)
            const pragasLoaded = Array.isArray(pragas) && pragas[0] && pragas[0].length > 0;
            if (pragasLoaded && !prefillOnce.current.praga) {
                const draftPestId = getDraftPestId(0);
                const draftPestCommon = draft.pragas_nome_comum || (draft.pragas && draft.pragas[0] && draft.pragas[0].nome_comum);
                const draftPestSci = draft.pragas_nome_cientifico || (draft.pragas && draft.pragas[0] && draft.pragas[0].nome_cientifico);

                let pestOption = null;
                if (draftPestId) {
                    pestOption = pragas[0].find(p => Number(p.value) === Number(draftPestId));
                }
                if (!pestOption && draftPestCommon && draftPestSci) {
                    const fullLabel = `${draftPestCommon} - ${draftPestSci}`.toLowerCase();
                    pestOption = pragas[0].find(p => (p.label || '').toLowerCase() === fullLabel);
                }
                if (!pestOption && draftPestCommon) {
                    const commonLower = draftPestCommon.toLowerCase();
                    pestOption = pragas[0].find(p => (p.label || '').toLowerCase().startsWith(commonLower));
                }

                if (pestOption) {
                    changePestOnRelation(pestOption, 0);
                    prefillOnce.current.praga = true;
                }
            }
    }, [props.recipeDraft, culturas, produtos, pragas, estadoId, culturaId, isCompendio, pragasId, maxRelations]);

    const getProdutos = async (index) => {
        // Evita sobrescrever opções quando já vieram do compêndio
        if (isCompendio === true && Array.isArray(produtos) && produtos[index] && produtos[index].length > 0) {
            return;
        }
        if (index === 0) {
            setProdutos([]);
            setLoading(true);
            try {
                const response = await api.get(`/produtos`);
                let responseProdutos = response.data.data;

                setTimeout(() => {
                    let produtosFormat = formatProdutos(responseProdutos);
                    let produtosArray = produtos;
                    produtosArray[index] = produtosFormat;
                    setProdutos(produtosArray);
                }, 200);

            } catch (error) {
            }
            setLoading(false);

        } else {
            setLoading(true);

            let p = produtos;

            if (p.length > 0) {
                setProdutos([]);

                let newP = [];

                p.map((pm, i) => {
                    if (i !== index) {
                        newP = [...newP, pm];
                    }
                })

                try {
                    const response = await api.get(`/produtos`);
                    let responseProdutos = response.data.data;

                    setTimeout(() => {
                        let produtosFormat = formatProdutos(responseProdutos);
                        newP[index] = produtosFormat;
                        setProdutos(newP);
                    }, 200);
                } catch (error) {
                }
                setLoading(false);
            }
        }
    };

    const getPragas = async (index) => {
        const hasRecipeSolicitada = hasReceitaSolicitada();
        if (hasRecipeSolicitada) {
            setDisabledPraga(false);
            return;
        }
        if (isCompendio === true && Array.isArray(pragas) && pragas[index] && pragas[index].length > 0) {
            setDisabledPraga(false);
            return;
        }
        setLoading(true);

        if (index === 0) {
            if (!hasRecipeSolicitada) {
            setPragas([]);
            }
            try {
                setDisabledPraga(true);
                const response = await api.get(`/pragas`);

                setTimeout(() => {
                    let responsePragas = response.data.data;
                    let pragasFormat = formatPragas(responsePragas);

                    let pragasArray = pragas;
                    pragasArray[index] = pragasFormat;

                    setPragas(pragasArray);
                    setDisabledPraga(false);
                }, 200);

            } catch (error) {

            }
        } else {


            let p = pragas;

            if (p.length > 0) {
               if (!hasRecipeSolicitada) {
                setPragas([]);
                }

                let newP = [];

                p.map((pm, i) => {
                    if (i !== index) {
                        newP = [...newP, pm];
                    }
                })

                try {
                    setDisabledPraga(true);
                    const response = await api.get(`/pragas`);

                    setTimeout(() => {
                        let responsePragas = response.data.data;
                        let pragasFormat = formatPragas(responsePragas);

                        newP[index] = pragasFormat;

                        setPragas(newP);
                        setDisabledPraga(false);
                    }, 200);
                } catch (error) {

                }
            }
        }
        setLoading(false);
    };

    const searchCompendio = async (produto = '*', cultura = '*', praga = '*', estado = '*', index, options = {}) => {
        try {
            const forceReceitaSolicitadaCompendio = options?.forceReceitaSolicitadaCompendio === true;
            const bypassReceitaSolicitadaGuard = options?.bypassReceitaSolicitadaGuard === true;
            if (!produto) {
                produto = '*'
            }
            if (!cultura) {
                cultura = '*'
            }
            if (!praga) {
                praga = '*'
            }
            if (!estado) {
                estado = '*'
            }

            const hasRecipeSolicitada = hasReceitaSolicitada();
            const canSearchRelation = produto !== '*' && cultura !== '*' && praga !== '*' && estado !== '*';
            if (hasRecipeSolicitada && !bypassReceitaSolicitadaGuard) {
                // ReceitaSolicitada: neste passo só busca compêndio 1x da 1ª relação.
                // Quando a praga já foi selecionada, apenas resolve a relação para abrir o accordion automaticamente.
                if (canSearchRelation) {
                    await searchRelationId(produto, cultura, praga, index);
                    return;
                }

                const isFirstRelation = index === 0;
                const hasRequiredParams = produto !== '*' && cultura !== '*' && estado !== '*';
                if (forceReceitaSolicitadaCompendio && hasRequiredParams) {
                    // busca sob demanda para relações seguintes ao abrir o select de praga
                } else {
                    if (!isFirstRelation || !hasRequiredParams || receitaSolicitadaFirstFetchDoneRef.current) {
                        return;
                    }
                    receitaSolicitadaFirstFetchDoneRef.current = true;
                }
            }


            if (produto === '*' && cultura === '*' && praga === '*' && estado === '*' && index === 0) {
                setExistDispensedProduct(false);
                setDispensedIndex('');
                setLoadingCompendio(false);
                setLoading(true);
                getCulturas();
                getPragas(0);
                getProdutos(0);
                setLoading(false);
            } else {
                setDisabledEstado(true);
                setDisabledCultura(true);
                setDisabledPraga(true);
                setDisabledProduto(true);

                compendioVersion.current[index] = (compendioVersion.current[index] || 0) + 1;
                const version = compendioVersion.current[index];

                const response = await api.get(`/compendio/${produto}/${cultura}/${praga}/${estado}`);
                if (!response) {
                    setDisabledEstado(false);
                    setDisabledCultura(false);
                    setDisabledPraga(false);
                    setDisabledProduto(false);
                    return;
                }

                if (version !== compendioVersion.current[index]) {
                    setDisabledEstado(false);
                    setDisabledCultura(false);
                    setDisabledPraga(false);
                    setDisabledProduto(false);
                    return;
                }

                let resolvedPestId = praga && praga !== '*' ? praga : null;
                // Só fica true depois de confirmar (abaixo) que o produto selecionado
                // realmente aparece nos resultados do compêndio para este estado -
                // evita resolver/manter uma relação (e o check verde) de um produto
                // que na verdade não está aprovado/disponível na UF atual.
                let produtoDisponivelNoEstado = false;

                if (response) {
                    let responseEstados = response.data.data.estados;
                    let responsePragas = response.data.data.pragas;
                    let responseProdutos = response.data.data.produtos;
                    let responseCulturas = response.data.data.culturas;

                    const allEmpty =
                        responseEstados.length === 0 &&
                        responsePragas.length === 0 &&
                        responseProdutos.length === 0 &&
                        responseCulturas.length === 0;

                    if (allEmpty && produto !== '*' && cultura !== '*' && estado !== '*') {
                        store.addNotification({
                            title: "Erro!",
                            message: "Não foram encontradas as relações de um ou mais produtos, tente novamente mais tarde.",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                        setDisabledEstado(false);
                        setDisabledCultura(false);
                        setDisabledPraga(false);
                        setDisabledProduto(false);
                        return;
                    }

                    setEstadosParaSelecionar([""]);
                    let estadosProibidos = [];

                    responseEstados.map(st => {
                        function buscaEstadosIguais(value) {
                            return value.value === st.uf;
                        }

                        const estadosFiltrados = state.filter(buscaEstadosIguais);

                        estadosProibidos.push(estadosFiltrados[0]);
                    })

                    setEstadosParaSelecionar(estadosProibidos);
                    setDisabledEstado(false);

                    setCulturas([""])
                    let culturasFormat = formatCulturas(responseCulturas);
                    // Rascunho multi-produto: restringe às culturas comuns a todos os produtos
                    const intersecaoDraft = culturasIntersecaoRef.current;
                    if (intersecaoDraft && intersecaoDraft.length > 0) {
                        culturasFormat = culturasFormat.filter(c => intersecaoDraft.some(ci => ci.value === c.value));
                    }
                    setCulturas(culturasFormat);
                    if (produto !== '*') culturaSetByCompendio.current = true;
                    setDisabledCultura(false);

                    const hasRecipeSolicitada = hasReceitaSolicitada();
                    let pragasFormat = formatPragas(responsePragas);
                    if (!hasRecipeSolicitada) {
                        setPragas([""]);
                    }
                    const nextPragas = Array.isArray(pragas) ? [...pragas] : [];
                    nextPragas[index] = pragasFormat;
                    setPragas(nextPragas);
                    setDisabledPraga(false);

                    const nextPragasId = Array.isArray(pragasId) ? [...pragasId] : [];
                    resolvedPestId = resolvePestIdFromOptions(pragasFormat, index, praga);
                    if (resolvedPestId) {
                        nextPragasId[index] = resolvedPestId;
                        setPragasId(nextPragasId);
                    }

                    setProdutos([""])
                    let produtosFormat = formatProdutos(responseProdutos);

                    produtoDisponivelNoEstado =
                        produto === '*' ||
                        produtosFormat.some(p => String(p.value) === String(produto));

                    if (produtosFormat.length === 1 && produto && produto !== '*') {
                        if (produtosFormat[0].dispensado === 1) {
                            setExistDispensedProduct(true);
                            setDispensedIndex(index);
                        } else {
                            setExistDispensedProduct(false);
                            setDispensedIndex('');
                        }
                    }

                    if (!hasRecipeSolicitada) {
                        setProdutos([""]);
                    }
                    const produtosArray = Array.isArray(produtos) ? [...produtos] : [];
                    produtosArray[index] = produtosFormat;
                    setProdutos(produtosArray);
                    setDisabledProduto(false);
                }

                if (produto !== '*' && cultura !== '*' && estado !== '*') {
                    if (produtoDisponivelNoEstado) {
                        const pestForRelation = resolvedPestId || (praga !== '*' ? praga : null);
                        if (pestForRelation) {
                            searchRelationId(produto, cultura, pestForRelation, index);
                        }
                    } else {
                        // Produto não aparece nos resultados do compêndio para esta UF
                        // (ex: em revisão) - sem isso a relação antiga (herdada de uma
                        // clonagem pra outra UF, por exemplo) ficava com o check verde
                        // sem avisar que na verdade não é válida aqui.
                        let r = Array.isArray(relations) ? [...relations] : [];
                        r[index] = 0;
                        setRelations(r);
                        props.updateRelationIds(r);
                        props.countRelations(r.length);

                        store.addNotification({
                            title: "Atenção!",
                            message: "O produto selecionado não está disponível para o estado escolhido. Selecione outro produto.",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 6000,
                                onScreen: true
                            }
                        });
                    }
                }

                setDisabledEstado(false);
                setDisabledCultura(false);
                setDisabledPraga(false);
                setDisabledProduto(false);
            }

        } catch (error) {
            setDisabledEstado(false);
            setDisabledCultura(false);
            setDisabledPraga(false);
            setDisabledProduto(false);
        }
    }

    const handleOpenPestSelect = (index) => {
        const hasRecipeSolicitada = hasReceitaSolicitada();
        if (!hasRecipeSolicitada) return;
        // Fluxo sequencial: só libera o próximo card quando o anterior estiver completo.
        if (index > 0 && !isRelationComplete(index - 1)) return;

        const produto = getProductIdForIndex(index);
        const cultura = getCulturaValue();
        const estado = getEstadoValue();
        const hasRequiredParams = produto && produto !== '*' && cultura && cultura !== '*' && estado && estado !== '*';
        if (!hasRequiredParams) return;

        const alreadyLoaded = Array.isArray(pragas) && Array.isArray(pragas[index]) && pragas[index].length > 0;
        if (alreadyLoaded) return;
        searchCompendio(produto, cultura, '*', estado, index, { forceReceitaSolicitadaCompendio: true });
    };

    const searchRelationId = async (produto, cultura, praga, index) => {
        setRelationLoading(index, true);
        try {

            const response = await api.get(`/relacoes/${produto}/${cultura}/${praga}`);

            if (response) {
                if (response.data.data.length === 1) {

                    if (response.data.data[0].agro_relations_exceptions.length > 0) {
                        let r = Array.isArray(relations) ? [...relations] : [];
                        let relationsId = []

                        response.data.data.map(rel => {
                            relationsId = [...relationsId, { relacao: rel }];
                        })

                        r[index] = relationsId;

                        setRelations(r);
                        props.updateRelationIds(r);
                        props.countRelations(r.length);

                        openBoxRelation(index, 7, r);

                        if (!(existDispensedProduct && dispensedIndex === index)) {
                            const next = Array(r.length).fill(false);
                            next[index] = true;
                            setOpenRelation(next);
                        }
                    } else {
                        let relationId = response.data.data[0].id;
                        let r = Array.isArray(relations) ? [...relations] : [];
                        r[index] = relationId;


                        if (relations[index] && relations[index] === relationId) {
                            openBoxRelation(index, 8.1, r);
                            setRelations(r);
                            props.updateRelationIds(r);

                        } else {
                            setRelations(r);
                            props.updateRelationIds(r);

                            props.countRelations(r.length);
                            openBoxRelation(index, 8, r);

                        }

                        setRelations(r);
                        props.updateRelationIds(r);
                        props.countRelations(r.length);
                        if (!(existDispensedProduct && dispensedIndex === index)) {
                            const next = Array(r.length).fill(false);
                            next[index] = true;
                            setOpenRelation(next);
                        }
                    }
                } else {
                    let relationsId = []
                    response.data.data.map(rel => {
                        relationsId = [...relationsId, { relacao: rel }];
                    })
                    let r = Array.isArray(relations) ? [...relations] : [];
                    r[index] = relationsId;

                    setRelations(r);

                    openBoxRelation(index, 9, r);

                    if (!(existDispensedProduct && dispensedIndex === index)) {
                        const next = Array(r.length).fill(false);
                        next[index] = true;
                        setOpenRelation(next);
                    }
                }
            }
        } catch (error) {

        } finally {
            setRelationLoading(index, false);
        }
    }

    const changeEstado = (estado) => {
        if (isErroNotRelation === true) {
            setIsErroNotRelation(false);
        }

        if (typeof estado === 'object') {
            if (estado.value === '' && estado.label === '') {
                setEstado('');

                if (produtosId[0] || culturaId.value || pragasId[0]) {
                    searchCompendio(produtosId[0], culturaId.value, pragasId[0], '*', 0);
                } else {
                    setEstadosParaSelecionar(state);
                }

            } else {
                setEstado(estado);
                if (estado.value !== estadoId.value) {
                    searchCompendio(produtosId[0], culturaId.value, pragasId[0], estado.value, 0);
                }
            }
        }
    }

    const changeCultura = (cultura) => {
        if (isErroNotRelation === true) {

            setIsErroNotRelation(false);
        }
        setLoading(true);

        if (isCompendio === true) {
            //Se compendio for TRUE e estiver sendo alterado justamente o valor que veio do compendio (index 0), o state isCompendio deve ser setado para FALSE
            if (culturaId) {
                if (cultura.value !== culturaId) {
                    setIsCompendio(false);
                }
            }
        }

        if (typeof cultura === 'object') {
            if (cultura.value === '' && cultura.label === '') {
                setCulturaId('');

                if (produtosId[0] || estadoId.value || pragasId[0]) {
                    searchCompendio(produtosId[0], '*', pragasId[0], estadoId.value, 0);
                }
            } else {
                setCulturaId(cultura);
                if (cultura.value !== culturaId.value) {
                    searchCompendio(produtosId[0], cultura.value, pragasId[0], estadoId.value, 0);
                }
            }
        }
        setLoading(false);
    }

    const changeProductOnRelation = (product, index) => {

        // Troca manual de produto invalida a interseção calculada a partir do rascunho
        culturasIntersecaoRef.current = null;

        if (isErroNotRelation === true) {

            setIsErroNotRelation(false);
        }

        if (typeof product === 'object') {

            let isComp = false

            if (isCompendio === true) {
                isComp = true;
                if (index === 0) {
                    //Se compendio for TRUE e estiver sendo alterado justamente o valor que veio do compendio (index 0), o state isCompendio deve ser setado para FALSE

                    if (produtosId[index]) {
                        if (product.value !== produtosId[index]) {
                            setIsCompendio(false);
                            isComp = false;
                        }
                    }
                }
            }

            const nextIds = Array.isArray(produtosId) ? [...produtosId] : [];
            nextIds[index] = product.value;
            setProdutosId(nextIds);

            const nextLabels = Array.isArray(produtosLabel) ? [...produtosLabel] : [];
            nextLabels[index] = product.label || '';
            setProdutosLabel(nextLabels);

            if (!(index > 0 && isLocked(index)) && !(isComp && index === 0)) {
                searchCompendio(product.value, culturaId.value, pragasId[index], estadoId.value, index);
            }

            if (relations.length === 1 && index === 0) {
                if (product.value === '') {
                    setOpenRelation([false]);
                    if (typeof product === 'object') {
                        if (product) {
                            if (produtosId[index] === "") {
                                let newList = [];

                                produtosId.map((p, i) => {
                                    if (i === index) {
                                        newList = [...newList, product.value];
                                    } else {
                                        newList = [...newList, p];
                                    }
                                });
                                setProdutosId(newList);
                            } else {
                                if (produtosId[index] === product.value) {

                                    let newList = [];

                                    produtosId.map((p, i) => {
                                        if (i === index) {
                                            newList = [...newList, product.value];
                                        } else {
                                            newList = [...newList, p];
                                        }
                                    });
                                    setProdutosId(newList);
                                } else {
                                    if (product.value === '') {
                                        let newList = [];

                                        produtosId.map((p, i) => {
                                            if (i === index) {
                                                newList = [...newList, product.value];
                                            } else {
                                                newList = [...newList, p];
                                            }
                                        });
                                        setProdutosId(newList);
                                    } else {
                                        let productsList = produtosId;

                                        productsList = [...productsList, product.value];

                                        setProdutosId(productsList);
                                    }
                                }
                            }
                        } else {
                            let productsList = produtosId;
                            productsList[index] = '';
                            setProdutosId(productsList);
                        }

                        if (isComp && index === 0) {
                            //Não deve consultar aqui
                        } else {
                            searchCompendio(product.value, culturaId.value, pragasId[index], estadoId.value, index);
                        }
                    }
                } else {
                    if (typeof product === 'object') {
                        if (product) {
                            if (produtosId[index] === "") {
                                let newList = [];

                                produtosId.map((p, i) => {
                                    if (i === index) {
                                        newList = [...newList, product.value];
                                    } else {
                                        newList = [...newList, p];
                                    }
                                });

                                setProdutosId(newList);

                            } else {
                                if (produtosId[index] === product.value) {

                                    let newList = [];

                                    produtosId.map((p, i) => {
                                        if (i === index) {
                                            newList = [...newList, product.value];
                                        } else {
                                            newList = [...newList, p];
                                        }
                                    });
                                    setProdutosId(newList);
                                } else {

                                    if (product.value === '') {
                                        let newList = [];

                                        produtosId.map((p, i) => {
                                            if (i === index) {
                                                newList = [...newList, product.value];
                                            } else {
                                                newList = [...newList, p];
                                            }
                                        });
                                        setProdutosId(newList);
                                    } else {
                                        let productsList = produtosId;

                                        productsList = [...productsList, product.value];
                                        setProdutosId(productsList);
                                    }
                                }
                            }
                        } else {
                            let productsList = produtosId;
                            productsList[index] = '';
                            setProdutosId(productsList);
                        }

                        if (isComp && index === 0) {
                            //Não deve consultar aqui
                        } else {
                            searchCompendio(product.value, culturaId.value, pragasId[index], estadoId.value, index);
                        }
                    }
                }
            } else {
                let newRelations = [];
                let newOpenRelations = [];

                relations.map((r, i) => {
                    if (i === index) {
                        newRelations[i] = 0;
                    } else {
                        newRelations[i] = r;
                    }
                })

                openRelation.map((o, i) => {
                    if (i === index) {
                        newOpenRelations[i] = false;
                    } else {
                        newOpenRelations[i] = o;
                    }
                })

                setRelations(newRelations);
                setOpenRelation(newOpenRelations);

                if (typeof product === 'object') {
                    if (product) {
                        if (produtosId[index] === "") {
                            let newList = [];

                            produtosId.map((p, i) => {
                                if (i === index) {
                                    newList = [...newList, product.value];
                                } else {
                                    newList = [...newList, p];
                                }
                            });

                            setProdutosId(newList);

                        } else {
                            if (produtosId[index] === product.value) {

                                let newList = [];

                                produtosId.map((p, i) => {
                                    if (i === index) {
                                        newList = [...newList, product.value];
                                    } else {
                                        newList = [...newList, p];
                                    }
                                });

                                setProdutosId(newList);
                            } else {

                                if (product.value === '') {
                                    let newList = [];

                                    produtosId.map((p, i) => {
                                        if (i === index) {
                                            newList = [...newList, product.value];
                                        } else {
                                            newList = [...newList, p];
                                        }
                                    });

                                    setProdutosId(newList);
                                } else {
                                    let productsList = produtosId;

                                    productsList = [...productsList, product.value];

                                    setProdutosId(productsList);
                                }
                            }
                        }
                    } else {
                        let productsList = produtosId;
                        productsList[index] = '';
                        setProdutosId(productsList);
                    }

                    if (isComp && index === 0) {
                        //Não deve consultar aqui
                    } else {
                        searchCompendio(product.value, culturaId.value, pragasId[index], estadoId.value, index);
                    }
                }
            }

            let productsLabels = produtosLabel;
            productsLabels[index] = product.label;
            setProdutosLabel(productsLabels);
        }
    }

    const changePestOnRelation = (pest, index) => {
        if (isErroNotRelation === true) {

            setIsErroNotRelation(false);
        }

        if (isCompendio === true && index === 0) {
            //Se compendio for TRUE e estiver sendo alterado justamente o valor que veio do compendio (index 0), o state isCompendio deve ser setado para FALSE
            if (pragasId[index]) {
                if (pest.value !== pragasId[index]) {
                    setIsCompendio(false);
                }
            }
        }


        if (typeof pest === 'object') {
            let isComp = false
            if (isCompendio === true) {
                isComp = true;
                if (index === 0) {
                    //Se compendio for TRUE e estiver sendo alterado justamente o valor que veio do compendio (index 0), o state isCompendio deve ser setado para FALSE
                    if (pragasId[index]) {
                        if (pest.value !== pragasId[index]) {
                            setIsCompendio(false);
                            isComp = false;
                        }
                    }
                }
            }

            if (relations.length === 1 && index === 0) {
                if (pest.value === '') {
                    setOpenRelation([false]);
                }
            } else {
                let newRelations = [];
                let newOpenRelations = [];

                relations.map((r, i) => {
                    if (i === index) {
                        newRelations[i] = 0;
                    } else {
                        newRelations[i] = r;
                    }
                })

                openRelation.map((o, i) => {
                    if (i === index) {
                        newOpenRelations[i] = false;
                    } else {
                        newOpenRelations[i] = o;
                    }
                })

                setRelations(newRelations);
                setOpenRelation(newOpenRelations);
            }

            if (typeof pest === 'object') {

                if (pest.value === '' && (!produtosId[index] || produtosId[index] === '') && culturaId === '' && estadoId === '') {
                    let pestsList = pragasId;
                    pestsList[index] = '';
                    setPragasId(pestsList);

                    getCulturas();
                    getPragas(index);
                    getProdutos(index);
                    setEstadosParaSelecionar(state);
                } else {
                    if (pest) {
                        if (pragasId[index] === "") {
                            let newList = [];

                            pragasId.map((p, i) => {
                                if (i === index) {
                                    newList = [...newList, pest.value];
                                } else {
                                    newList = [...newList, p];
                                }
                            });

                            setPragasId(newList);
                        } else {

                            if (pragasId[index] === pest.value) {

                                let newList = [];

                                pragasId.map((p, i) => {
                                    if (i === index) {
                                        newList = [...newList, pest.value];
                                    } else {
                                        newList = [...newList, p];
                                    }
                                });

                                setPragasId(newList);
                            } else {
                                if (pest.value === '') {
                                    let newList = [];

                                    pragasId.map((p, i) => {
                                        if (i === index) {
                                            newList = [...newList, pest.value];
                                        } else {
                                            newList = [...newList, p];
                                        }
                                    });

                                    setPragasId(newList);
                                } else {
                                    let pestsList = pragasId;
                                    pestsList = [...pestsList, pest.value];
                                    setPragasId(pestsList);
                                }
                            }
                        }
                    } else {
                        let pestsList = pragasId;
                        pestsList[index] = '';
                        setPragasId(pestsList);
                    }
                }
            }


            if (!(index > 0 && isLocked(index))) {
                if (!(isComp && index === 0)) {
                    const produtoId = getProductIdForIndex(index);
                    searchCompendio(produtoId, culturaId.value, pest.value, estadoId.value, index);
                }
            }


        }
    }

    const getQuantidadeRelacoes = async (estado) => {
        try {
            if (estado.value != '' && estado.value !== '*') {
                const response = await api.get(`/relacoes/quantidade/${estado.value}`);
                if (response) {
                    updateQuantidadeRelations(response.data.data.quantidade);
                    setMaxRelations(response.data.data.quantidade);
                }
            } else {
                updateQuantidadeRelations(1);
                setMaxRelations(1);
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const openBoxRelation = async (index, id, currentRelations = null) => {
        setBoxOpen(true)
        const relationsSource = Array.isArray(currentRelations) ? currentRelations : relations;
        let rels = Array.isArray(openRelation) ? [...openRelation] : [];
        let newRels = [];
        const isProceedAction = id === 11;
        const canShowIncompleteRelationAlert =
            !showIncompleteRelationAlertOnProceedOnly || isProceedAction;
        const shouldBlockIncompleteRelationAlertByOnceRule =
            showIncompleteRelationAlertOnlyOnce && hasShownIncompleteRelationAlertRef.current;

        const isPrevComplete = (idx) => {
            if (existDispensedProduct && dispensedIndex === idx) return true;
            const info = relationsInfoArray[idx];
            if (!info) return false;
            if (relations[idx] === 0) return false;
            if (info.isException) {
                if (!info.fase || (Array.isArray(info.fase) && info.fase.length === 0)) return false;
            }
            const hasModalidade = !!(info.modalidadeAplicacao && info.modalidadeAplicacao.value);
            const hasDose = !!info.dose;
            const hasNum = !!info.numeroAplicacoes;
            const hasArea = !!info.areaTratar;
            const hasQtd = !!info.quantidadeAdquirir;
            return hasModalidade && hasDose && hasNum && hasArea && hasQtd;
        };

        const hasRecipeSolicitada = hasReceitaSolicitada();
        if (hasRecipeSolicitada && index > 0) {
            for (let i = 0; i < index; i++) {
                if (!isPrevComplete(i)) {
                    store.addNotification({
                        title: "Atenção!",
                        message: `Preencha todas as informações do produto ${i + 1} antes de prosseguir!`,
                        type: "warning",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: { duration: 5000, onScreen: true }
                    });
                    return;
                }
            }
        }

        if (rels.length !== relationsSource.length) {
            relationsSource.map((r, i) => {
                if (!rels[i]) {
                    rels[i] = false;
                }
            })
        }

        if (existDispensedProduct === false) {
            if (relationsSource[index] === 0) {
                const produto = getProductIdForIndex(index);
                const cultura = getCulturaValue();
                const praga = getPestIdForIndex(index);
                const estado = getEstadoValue();
                if (produto && cultura && praga && estado) {
                    await searchRelationId(produto, cultura, praga, index);
                    // segue para toggle após resolver relationId
                } else {
                setBoxOpen(false)
                    if (canShowIncompleteRelationAlert && !shouldBlockIncompleteRelationAlertByOnceRule) {
                        hasShownIncompleteRelationAlertRef.current = true;
                store.addNotification({
                    title: "Erro!",
                    message: `A relação está incompleta!`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                    }

                    //AQUI DEU RUIM NA EMISSAO
                    // if (relations[index] === 0) {
                    // const produto = getProductIdForIndex(index);
                    // const cultura = culturaId && culturaId.value ? culturaId.value : '';
                    // const praga = pragasId[index];
                    // const estado = estadoId && estadoId.value ? estadoId.value : '';
                    // if (produto && cultura && praga && estado) {
                    //     await searchRelationId(produto, cultura, praga, index);
                    //     // segue para toggle após resolver relationId
                    // } else {
                    //     setBoxOpen(false)
                    //     store.addNotification({
                    //         title: "Erro!",
                    //         message: `A relação está incompleta!`,
                    //         type: "danger",
                    //         insert: "top",
                    //         container: "top-right",
                    //         animationIn: ["animated", "fadeIn"],
                    //         animationOut: ["animated", "fadeOut"],
                    //         dismiss: {
                    //             duration: 4000,
                    //             onScreen: true
                    //         }
                    //     });
                    //     return;
                    // }
                }
            } else {
                rels.map((value, i) => {

                    if (i === index) {
                        newRels[i] = !value;
                    } else {
                        if (value === true) {
                            newRels[i] = !value;
                        } else {
                            newRels[i] = value;
                        }
                    }
                });
                setOpenRelation(newRels);
            }
        }
    }

    const closeAllRelations = (relations) => {
        setCloseAll(true);

        relations.map((rel, i) => {
            if (rel === true) { //Se card estiver aberta
                openBoxRelation(i, 10);
            }
        })
    }

    const addNewRelation = () => {

        if (existDispensedProduct === true) {
            store.addNotification({
                title: "Erro!",
                message: `O produto selecionado está dispensado de receituário agronômico!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        } else {
            if (!loading && !disabledEstado && !disabledCultura && !disabledPraga && !disabledProduto) {
                if (!estadoId) {
                    store.addNotification({
                        title: "Erro!",
                        message: `Primeiro selecione um estado!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                } else {
                    if (!culturaId) {
                        store.addNotification({
                            title: "Erro!",
                            message: `Primeiro selecione uma cultura!`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    } else {

                        const lastValue = relations[relations.length - 1];

                        if (lastValue === 0) {
                            store.addNotification({
                                title: "Erro!",
                                message: `Complete a prescrição anterior para adicionar mais produtos!`,
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        } else {
                            if (maxRelations) {
                                if (relations.length < maxRelations) {
                                    let indexNewRelation = relations.length

                                    const openRelationsLength = openRelation.length;
                                    let existOpen = false;
                                    let indexIsOpen = 0;

                                    if (openRelationsLength > 0) {
                                        openRelation.map((value, i) => {
                                            if (value === true) {
                                                existOpen = true;
                                                indexIsOpen = i;
                                            }
                                        })

                                        if (existOpen) {
                                            let rels = openRelation;

                                            let newRels = [];

                                            rels.map((value, i) => {
                                                if (i === indexIsOpen) {
                                                    if (value === true) {
                                                    }
                                                    newRels[i] = !value;
                                                } else {
                                                    if (value === true) {
                                                        newRels[i] = !value;
                                                    } else {
                                                        newRels[i] = value;
                                                    }
                                                }
                                            });

                                            newRels = [...newRels, false];
                                            setOpenRelation(newRels);
                                        } else {
                                            setOpenRelation([...openRelation, false]);
                                        }
                                    }
                                    setRelations([...relations, 0]);
                                    setRelationsInfoArray([...relationsInfoArray, []]);

                                    let prd = produtos;
                                    let prg = pragas;

                                    setTimeout(() => {
                                        setProdutos([]);
                                        setPragas([]);
                                    }, 100);

                                    setTimeout(() => {
                                        prd[indexNewRelation] = [];
                                        prg[indexNewRelation] = [];

                                    }, 100);

                                    setTimeout(() => {
                                        setProdutos(prd);
                                        setPragas(prg);
                                    }, 100);

                                    searchCompendio('*', culturaId.value, '*', estadoId.value, indexNewRelation)


                                } else {
                                    store.addNotification({
                                        title: "Erro!",
                                        message: `Você alcançou o limite de produtos permitidos!`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                }
                            } else {
                                if (relations.length < 10) {
                                    let indexNewRelation = relations.length

                                    const openRelationsLength = openRelation.length;
                                    let existOpen = false;
                                    let indexIsOpen = 0;

                                    if (openRelationsLength > 0) {
                                        openRelation.map((value, i) => {
                                            if (value === true) {
                                                existOpen = true;
                                                indexIsOpen = i;
                                            }
                                        })

                                        if (existOpen) {
                                            let rels = openRelation;
                                            let newRels = [];

                                            rels.map((value, i) => {
                                                if (i === indexIsOpen) {
                                                    newRels[i] = !value;
                                                } else {
                                                    if (value === true) {
                                                        newRels[i] = !value;
                                                    } else {
                                                        newRels[i] = value;
                                                    }
                                                }
                                            });

                                            newRels = [...newRels, false];
                                            setOpenRelation(newRels);
                                        } else {
                                            setOpenRelation([...openRelation, false]);
                                        }
                                    }
                                    setRelations([...relations, 0]);
                                    setRelationsInfoArray([...relationsInfoArray, []]);

                                    let prd = produtos;
                                    let prg = pragas;

                                    setTimeout(() => {
                                        setProdutos([]);
                                        setPragas([]);
                                    }, 100);

                                    setTimeout(() => {
                                        prd[indexNewRelation] = [];
                                        prg[indexNewRelation] = [];

                                    }, 100);

                                    setTimeout(() => {
                                        setProdutos(prd);
                                        setPragas(prg);
                                    }, 100);

                                    searchCompendio('*', culturaId.value, '*', estadoId.value, indexNewRelation)
                                } else {
                                    store.addNotification({
                                        title: "Erro!",
                                        message: `Você alcançou o limite de produtos permitidos!`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    const saveRelationInfo = (relationInfo, index) => {
        const safePrev = Array.isArray(relationsInfoArray) ? relationsInfoArray : [];
        const relArray = [...safePrev];
        relArray[index] = relationInfo;
        setRelationsInfoArray(relArray);

        if (index === 0) {
            setSaveDate(relationInfo.date);
        }

        updateValues(relArray, culturaId, estadoId);

        if (relArray[index].erro === true) {
            setIsErroNotRelation(true);
        } else {
            setIsErroNotRelation(false);
        }

        // ReceitaSolicitada: por enquanto não avança automaticamente a consulta para a próxima relação.
        // O próximo passo (sequencial) será tratado de forma controlada em ajuste posterior.
    }

    const removePragas = async (newPragas, index) => {
        let newArray = [];
        newPragas.map((p, i) => {
            if (i !== index) {
                newArray = [...newArray, p];
            } else {
            }
        });
        return newArray;
    }

    const removeProdutos = async (newProdutos, index) => {
        let newArray = [];
        newProdutos.map((p, i) => {
            if (i !== index) {
                newArray = [...newArray, p];
            } else {
            }
        });
        return newArray;
    }

    const removeProdutosLabel = async (produtosLabel, index) => {
        let newArray = [];
        produtosLabel.map((p, i) => {
            if (i !== index) {
                newArray = [...newArray, p];
            } else {
            }
        });
        return newArray;
    }

    const removeRelations = async (newRelations, index) => {
        let newArray = [];
        newRelations.map((p, i) => {
            if (i !== index) {
                newArray = [...newArray, p];
            } else {
            }
        });
        return newArray;
    }

    const removeOpenRelations = async (newOpenRelations, index) => {
        let newArray = [];
        newOpenRelations.map((p, i) => {
            if (i !== index) {
                newArray = [...newArray, p];
            } else {
            }
        });
        return newArray;
    }

    const removeRelationsInfoArray = async (newRelationsArray, index) => {
        let newArray = [];
        newRelationsArray.map((p, i) => {
            if (i !== index) {
                newArray = [...newArray, p];
            } else {
            }
        });
        return newArray;
    }

    const validaIndexRelations = async (newRelationsArray) => {
        let newRelationsIndoValidated = [];
        newRelationsArray.map((r, i) => {
            if (r.index > i) {
                newRelationsIndoValidated = [...newRelationsIndoValidated, {
                    areaTratar: r.areaTratar,
                    date: r.date,
                    dose: r.dose,
                    equipamento: r.equipamento,
                    index: i,
                    relationId: r.relationId,
                    modalidadeAplicacao: r.modalidadeAplicacao,
                    numeroAplicacoes: r.numeroAplicacoes,
                    quantidadeAdquirir: r.quantidadeAdquirir,
                    unidadeQuantidadeAdquirir: r.unidadeQuantidadeAdquirir,
                    volumeCalda: r.volumeCalda
                }]
            } else if (r.index === i) {
                newRelationsIndoValidated = [...newRelationsIndoValidated, r];
            }
        });
        return newRelationsIndoValidated;
    }

    const loadingNewSelectOptions = async (pragas, produtos) => {
        let length = pragas.length;

        if (length === produtos.length) {
            let load = [];
            for (let i = 0; i < length; i++) {
                try {
                    const response = await api.get(
                        `/compendio/${produtos[i]}/${culturaId ? culturaId.value : "*"}/${pragas[i]}/${estadoId ? estadoId.value : "*"}`
                    );

                    if (response) {
                        let responsePragas = response.data.data.pragas;
                        let responseProdutos = response.data.data.produtos;

                        setPragas([""])
                        let pragasFormat = formatPragas(responsePragas);
                        let pragasArray = pragas;
                        pragasArray[i] = pragasFormat
                        setPragas(pragasArray);

                        setProdutos([""])
                        let produtosFormat = formatProdutos(responseProdutos);
                        let produtosArray = produtos;
                        produtosArray[i] = produtosFormat;
                        setProdutos(produtosArray);

                        load = [...load, true];
                    } else {
                        load = [...load, false];
                    }
                } catch (error) {
                    load = [...load, false];
                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(error),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                    setIsErroNotRelation(true);
                }
            }

            if (load.length === length) {
                let existFalse = false;
                load.map((l) => {
                    if (l === false) {
                        existFalse = true;
                    }
                });

                if (!existFalse) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const deleteRelation = async (index) => {
        setIsLoadongRelations(true);

        if (relations.length === 1 && index === 0) {
            // setRelationsInfo([]);
            setRelations([]);
            setExistDispensedProduct(false);

            setPragasId([]);
            setProdutosId([]);

            setTimeout(() => {
                setRelations([0]);

                setDisabledEstado(true);
                setDisabledCultura(true);
                setDisabledPraga(true);
                setDisabledProduto(true);

                try {
                    if (culturaId || estadoId) {
                        api.get(
                            `/compendio/*/${culturaId ? culturaId.value : "*"}/*/${estadoId ? estadoId.value : "*"}`
                        ).then(response => {
                            if (response) {

                                let responseEstados = response.data.data.estados;
                                let responsePragas = response.data.data.pragas;
                                let responseProdutos = response.data.data.produtos;
                                let responseCulturas = response.data.data.culturas;

                                setEstadosParaSelecionar([""]);
                                let estadosProibidos = [];

                                responseEstados.map(st => {
                                    function buscaEstadosIguais(value) {
                                        return value.value === st.uf;
                                    }

                                    const estadosFiltrados = state.filter(buscaEstadosIguais);

                                    estadosProibidos.push(estadosFiltrados[0]);
                                })

                                setEstadosParaSelecionar(estadosProibidos);
                                setDisabledEstado(false);

                                setCulturas([""])
                                let culturasFormat = formatCulturas(responseCulturas);
                                setCulturas(culturasFormat);
                                setDisabledCultura(false);

                                setPragas([""])
                                let pragasFormat = formatPragas(responsePragas);
                                const nextPragas = Array.isArray(pragas) ? [...pragas] : [];
                                nextPragas[index] = pragasFormat;
                                setPragas(nextPragas);
                                setDisabledPraga(false);

                                setProdutos([""])
                                let produtosFormat = formatProdutos(responseProdutos);
                                let produtosArray = produtos;
                                produtosArray[index] = produtosFormat;
                                setProdutos(produtosArray);
                                setDisabledProduto(false);

                                updateValues([], culturaId, estadoId);
                            }
                        })
                    } else {
                        setLoading(true);
                        getCulturas();
                        getPragas(0);
                        getProdutos(0);
                        setLoading(false);
                        setIsLoadongRelations(false);
                        setDisabledEstado(false);
                        setDisabledCultura(false);
                        setDisabledPraga(false);
                        setDisabledProduto(false);
                        updateValues([], '', '');
                    }

                } catch (e) {
                    setDisabledEstado(false);
                    setDisabledCultura(false);
                    setDisabledPraga(false);
                    setDisabledProduto(false);

                    setIsErroNotRelation(true);

                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(e),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }

                setIsLoadongRelations(false);
            }, 1000);


        } else {
            let newPragas = pragasId;
            let newProdutos = produtosId;
            let newRelations = relations;
            let newOpenRelations = openRelation;
            let newRelationInfoArray = relationsInfoArray;
            let newProdutosLabel = produtosLabel;

            setRelations([]);

            if (existDispensedProduct === true && dispensedIndex === index) {
                setExistDispensedProduct(false);
                setDispensedIndex('');
            }

            newPragas = await removePragas(pragasId, index);
            newProdutos = await removeProdutos(produtosId, index);
            newRelations = await removeRelations(relations, index);
            newOpenRelations = await removeOpenRelations(openRelation, index);
            newRelationInfoArray = await removeRelationsInfoArray(relationsInfoArray, index);
            newProdutosLabel = await removeProdutosLabel(produtosLabel, index);

            if (newRelationInfoArray) {
                newRelationInfoArray = await validaIndexRelations(newRelationInfoArray);

                if (newRelationInfoArray) {
                    setTimeout(() => {
                        removeArraysPragas(newPragas);
                        removeArraysProdutos(newProdutos);
                        setRelations(newRelations);
                        setOpenRelation(newOpenRelations);
                        setRelationsInfoArray(newRelationInfoArray);
                        setProdutosLabel(newProdutosLabel)

                        props.countRelations(newRelationInfoArray.length);

                        updateValues(newRelationInfoArray, culturaId, estadoId, newProdutosLabel);
                    }, 300);

                    let isLoadingNewSelectOptions = false;
                    isLoadingNewSelectOptions = await loadingNewSelectOptions(newPragas, newProdutos);

                    setTimeout(() => {
                        setIsLoadongRelations(false);
                    }, 1000);
                }
            }

        }

    }

    const removeArraysProdutos = (produtosArrayIdList) => {
        let newArray = [];
        produtosArrayIdList.map((p, i) => {
            if (typeof p === 'object') {
                newArray = [...newArray, p[0].value];
            } else {
                newArray = [...newArray, p];
            }
        })

        setProdutosId(newArray);
    }

    const removeArraysPragas = (pragasArrayIdList) => {
        let newArray = [];
        pragasArrayIdList.map((p, i) => {
            if (typeof p === 'object') {
                newArray = [...newArray, p[0].value];
            } else {
                newArray = [...newArray, p];
            }
        })
        setPragasId(newArray);
    }

    const changeRelationId = (id, index) => {
        let relationsIds = [];

        relations.map((r, i) => {
            if (i === index) {
                relationsIds = [...relationsIds, id];
            } else {
                relationsIds = [...relationsIds, r];
            }
        });

        setRelations(relationsIds);
    }

    const updateValues = (relations, cultura, estado, produtos) => {
        let computedProdutos = (Array.isArray(produtos) && produtos.length > 0) ? produtos : produtosLabel;
        const orders = Array.isArray(props?.recipeDraft?.agro_prescriptions_relations_orders) ? props.recipeDraft.agro_prescriptions_relations_orders : [];
        if (orders.length > 0) {
            const byIndex = orders.map(o => `${o.nome_comercial} - ${o.fabricante}`);
            const maxLen = Math.max(computedProdutos.length || 0, byIndex.length);
            const merged = [];
            for (let i = 0; i < maxLen; i++) {
                merged[i] = computedProdutos && computedProdutos[i] ? computedProdutos[i] : byIndex[i];
            }
            computedProdutos = merged;
        }
        const payload = {
            relations,
            cultura,
            estado,
            produtos: computedProdutos
        };

        props.update(payload);
    }

    const loadCompendio = async (compendio) => {
        const totalRelations = Array.isArray(compendio) ? compendio.length : 0;
        if (totalRelations > 0) {
            setRelations((prev) => {
                const safePrev = Array.isArray(prev) ? [...prev] : [];
                for (let i = 0; i < totalRelations; i++) {
                    if (typeof safePrev[i] === 'undefined') {
                        safePrev[i] = 0;
                    }
                }
                return safePrev;
            });
        }

        const loadRelation = async (compendio, index) => {
            setDisabledEstado(true);
            setDisabledCultura(true);
            setDisabledPraga(true);
            setDisabledProduto(true);

            const {
                relacaoId,
                produto,
                praga,
                cultura,
                estado,
                modoAplicacao,
                area,
                dose,
                numApli,
                quantidade,
                equipamento: equipamentoClonado
            } = compendio;

            const nextRelationId = parseInt(relacaoId);
            setRelations((prev) => {
                const safePrev = Array.isArray(prev) ? prev : [];
                if (safePrev[index] === nextRelationId) {
                    return safePrev;
                }
                const next = [...safePrev];
                next[index] = nextRelationId;
                return next;
            });

            let relationInfoFromCompendio = {
                index,
                relationId: nextRelationId || 0,
                modalidadeAplicacao: modoAplicacao ? modoAplicacao : '',
                dose: dose ? dose : '',
                areaTratar: area ? area : '',
                numeroAplicacoes: numApli ? numApli : '',
                quantidadeAdquirir: quantidade ? quantidade : '',
                unidadeQuantidadeAdquirir: '',
                volumeCalda: '',
                equipamento: equipamentoClonado || ''
            };

            try {
                const p = produto || '*';
                const c = cultura || '*';
                const pg = praga || '*';
                const e = estado || '*';

                const response = await api.get(`/compendio/${p}/${c}/${pg}/${e}`);

                compendioVersion.current[index] = (compendioVersion.current[index] || 0) + 1;
                const localVersion = compendioVersion.current[index];
                // console.log("4")
                // const response = await api.get(`/compendio/${produto}/${cultura}/${praga}/${estado ? estado : '*'}`);

                if (!response || localVersion !== compendioVersion.current[index]) {
                    setDisabledEstado(false);
                    setDisabledCultura(false);
                    setDisabledPraga(false);
                    setDisabledProduto(false);
                    return;
                }

                if (response) {
                    if (nextRelationId) {
                        try {
                            const responseRelation = await api.get(`/relacoes/${nextRelationId}`);
                            const relationData = responseRelation?.data?.data;
                            if (relationData) {
                                relationInfoFromCompendio = {
                                    ...relationInfoFromCompendio,
                                    unidadeQuantidadeAdquirir:
                                        relationData?.unidade_dosagem?.unidade_quantidade_adquirir
                                        || relationData?.unidade_quantidade_adquirir
                                        || '',
                                    volumeCalda: relationData?.volume_calda || '',
                                    // Nao sobrescreve o equipamento vindo do clone: /relacoes/:id
                                    // consulta agro_relations, que nao tem essa coluna - o acesso
                                    // resolvia undefined e zerava o valor.
                                    equipamento: equipamentoClonado || ''
                                };
                            }
                        } catch (error) {
                            // Mantém fallback do clone mesmo se a consulta de detalhes falhar.
                        }
                    }

                    setRelationsInfoArray((prev) => {
                        const safePrev = Array.isArray(prev) ? prev : [];
                        const next = [...safePrev];
                        next[index] = relationInfoFromCompendio;
                        return next;
                    });

                    let responseEstados = response.data.data.estados;
                    let responsePragas = response.data.data.pragas;
                    let responseProdutos = response.data.data.produtos;
                    let responseCulturas = response.data.data.culturas;

                    let estadosProibidos = [];

                    responseEstados.map(st => {
                        function buscaEstadosIguais(value) {
                            return value.value === st.uf;
                        }

                        const estadosFiltrados = state.filter(buscaEstadosIguais);

                        estadosProibidos.push(estadosFiltrados[index]);
                    })

                    setEstadosParaSelecionar(estadosProibidos);
                    setDisabledEstado(false);

                    //Cultura
                    let culturasFormat = formatCulturas(responseCulturas);
                    setCulturas(culturasFormat);

                    let selectedCultura = null;

                    if (cultura && cultura !== '*') {
                        selectedCultura = culturasFormat.find(c => c.value == cultura);
                    }

                    if (!selectedCultura && culturasFormat.length === 1) {
                        selectedCultura = culturasFormat[0];
                    }
                    
                    if (selectedCultura) {
                        setCulturaId(selectedCultura);
                    } else if (culturasFormat.length === 1) {
                        setCulturaId(culturasFormat[0]);
                    }

                        if (estado && estado !== '*') {
                            const estadoCompleto = Estados.find(e => e.value === estado);
                            if (estadoCompleto) {
                                setEstado(estadoCompleto);
                            } else {
                                setEstado({ value: estado, label: estado });
                        }
                    }

                    //Pragas
                    const hasRecipeSolicitada = hasReceitaSolicitada();
                    let pragasFormat = formatPragas(responsePragas);
                    let pragasOptions = Array.isArray(pragas) ? [...pragas] : [];

                    if (!hasRecipeSolicitada) {
                        setPragas([]);
                    }

                    pragasOptions[index] = pragasFormat;
                    setPragas(pragasOptions);

                    let pst = Array.isArray(pragasId) ? [...pragasId] : [];
                    pst[index] = resolvePestIdFromOptions(pragasFormat, index, praga);
                    setPragasId(pst);
                    setDisabledPraga(false);


                    //Produtos
                    let produtosFormat = formatProdutos(responseProdutos);
                    const produtosOptions = Array.isArray(produtos) ? [...produtos] : [];
                    produtosOptions[index] = produtosFormat;

                    if (!hasRecipeSolicitada) {
                        setProdutos([]);
                    }

                    setProdutos(produtosOptions);

                    let prd = Array.isArray(produtosId) ? [...produtosId] : [];
                    const productFromParam = produto && produto !== '*' ? Number(produto) : '';
                    const productExists = produtosFormat.find(p => p.value === productFromParam);

                    // Mesmo aviso usado em searchCompendio (busca manual): o produto
                    // clonado não aparece nos resultados do compêndio pra esse
                    // estado/cultura/praga (ex: em revisão) - sem isso os campos
                    // ficavam em branco silenciosamente, sem explicar o motivo.
                    if (productFromParam && !productExists) {
                        setRelations((prev) => {
                            const safePrev = Array.isArray(prev) ? [...prev] : [];
                            safePrev[index] = 0;
                            return safePrev;
                        });

                        store.addNotification({
                            title: "Atenção!",
                            message: "O produto selecionado não está disponível para o estado escolhido. Selecione outro produto.",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 6000,
                                onScreen: true
                            }
                        });

                        setDisabledEstado(false);
                        setDisabledCultura(false);
                        setDisabledPraga(false);
                        setDisabledProduto(false);
                        return;
                    }

                    prd[index] = productExists ? productExists.value : (produtosFormat[0] ? produtosFormat[0].value : '');

                    let productsLabels = Array.isArray(produtosLabel) ? [...produtosLabel] : [];
                    productsLabels[index] = productExists
                        ? productExists.label
                        : (produtosFormat.length === 1 ? produtosFormat[0].label : '');
                    setProdutosLabel(productsLabels);

                    setProdutosId(prd);
                    setDisabledProduto(false);

                    if (
                        !nextRelationId &&
                        prd[index] &&
                        (cultura || (selectedCultura && selectedCultura.value)) &&
                        pst[index] &&
                        (estado || estado === "")
                    ) {
                        await searchRelationId(prd[index], (cultura && cultura !== '*') ? cultura : selectedCultura.value, pst[index], index);
                    }

                    setDisabledEstado(false);
                    setDisabledCultura(false);

                }
            } catch (e) {
                setDisabledEstado(false);
                setDisabledCultura(false);
                setDisabledPraga(false);
                setDisabledProduto(false);

                setIsErroNotRelation(true);

                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(e),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }

        }

        for (let i = 0; i < compendio.length; i++) {
            const c = compendio[i];
            await loadRelation(c, i);
        }

        props.countRelations(compendio.length);
    }

    const validaFirstPrescriptTest = async () => {
        let existPrescript = localStorage.getItem('@agroreceita:exist_prescription');

        if (existPrescript === 'false') {
            let user = JSON.parse(localStorage.getItem('@userinfo'));
            let uf = user.uf;

            changeEstado({ value: uf, label: uf });
        } else {
            setLoadingCompendio(false);
            setLoading(true);
            getCulturas();
            getPragas(0);
            getProdutos(0);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (props.isCompendio) {
            setIsCompendio(true);

            // Quando já existem parâmetros de compêndio (clonagem via URL),
            // loadCompendio/loadRelation já busca e preenche cultura/produto/
            // praga do índice 0 com as opções corretas (filtradas pelo
            // /compendio específico). Chamar getCulturas/getProdutos(0)/
            // getPragas(0) aqui corre em paralelo com essa busca e, se a
            // resposta genérica (sem filtro) chegar depois, sobrescreve as
            // opções certas - o valor selecionado (ID) continua válido, mas
            // o texto some porque o ID não é mais encontrado na lista de
            // opções exibida.
            const hasCompendioParams = Array.isArray(compendioParams) && compendioParams.length > 0;
            if (!hasCompendioParams) {
                getCulturas();
                getProdutos(0);
                getPragas(0);
            }

            loadCompendio(compendioParams)

            setTimeout(() => {
                validaFirstPrescriptTest();
            }, 1500);
        } else {
            validaFirstPrescriptTest();
            // setLoadingCompendio(false);
            // setLoading(true);
            // getCulturas();  
            // getPragas(0);
            // getProdutos(0);
            // setLoading(false);
        }
    }, [])

    useEffect(() => {
        if (estadoId) {
            if (props.maxRelations !== false) {
                getQuantidadeRelacoes(estadoId);
            } else {
                setMaxRelations(false);
            }
        }
    }, [estadoId])

    useEffect(() => {
        if (produtosId.length > 0) {
            let remove = false;
            produtosId.map((p) => {
                if (typeof p === 'object') {
                    remove = true;
                }
            })

            if (remove) {
                removeArraysProdutos(produtosId);
            } else {
                // if (isCompendio && loadingCompendio) {
                //     continueToCompendio();
                // }
            }
        }
    }, [produtosId])

    useEffect(() => {

        if (pragasId.length > 0) {
            let remove = false;
            pragasId.map(p => {
                if (typeof p === 'object') {
                    remove = true;
                }
            })

            if (remove) {
                removeArraysPragas(pragasId);
            } else {
                // if (isCompendio && loadingCompendio) {
                //     continueToCompendio();
                // }
            }
        }
    }, [pragasId])

    useEffect(() => {
        if (isErroNotRelation === true) {
            setIsErroNotRelation(false);
        }

        if (culturaId === '' || estadoId === '') {
            setOpenRelation([false]);
        }

    }, [culturaId, estadoId]);

    useEffect(() => {
        props.updateRelationIds(relations)
        props.countRelations(relations.length);
    }, [relations])

    useEffect(() => {

        if (openRelation.indexOf(true) == -1 && closeAll === true) {
            setCloseAll(false);
            setTimeout(() => {
                props.enviaReceita();
            }, 300);
        }
        props.updateOpenRelations(openRelation);
    }, [openRelation])

    useEffect(() => {
        if (startValidation === true) {

            if (openRelation.indexOf(true) == -1) {
                //Está tudo fechado!

                setTimeout(() => {
                    props.enviaReceita();
                }, 300);
            } else {
                //Tem relações abertas
                closeAllRelations(openRelation);
            }
        }
    }, [startValidation])

    useEffect(() => {
        props.updateErrorStepOne(isErroNotRelation)
    }, [isErroNotRelation])

    useEffect(() => {
        updateValues(relationsInfoArray, culturaId, estadoId, produtosLabel);
    }, [relationsInfoArray, culturaId, estadoId, produtosLabel])

    useEffect(() => {
        if (disabledEstado === false && disabledCultura === false && disabledPraga === false && disabledProduto === false) {
            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [disabledEstado, disabledCultura, disabledPraga, disabledProduto])

    useEffect(() => {
        // Não sobrescrever se já foi definido (ex.: rascunho, compêndio ou seleção do usuário)
        if (estadoId && typeof estadoId === 'object' && estadoId.value) {
            return;
        }

            const getInfo = JSON.parse(localStorage.getItem('@userinfo'));

            if (getInfo?.uf && getInfo?.contrato?.agro_plan_config?.nome_plano === 'TESTE GRÁTIS') {
            const estado = estados.find(estado => estado.value === getInfo.uf);
                if (estado) {
                    setEstado({ value: estado.value, label: estado.label });
                }
            }
        // Caso contrário, manter vazio sem forçar { value: '', label: '' }
    }, []);

    useEffect(() => {
        const hasRecipe = hasReceitaSolicitada();
        if (estadoId && !hasRecipe) {
            getPragas(0);
        }
    }, [estadoId])

    return (
        <Container>

            <FormContainer>
                <Card className="step01">
                    <TaglinePSpan color={theme.colors.gray.Cinza_2}>Comece por onde quiser</TaglinePSpan>

                    <Row style={{ maxWidth: '700px', padding: "0" }}>
                        <S.ContainerInputsSelects>
                            <div className="selectValue">
                                <SelectV2StepOne
                                    name="estado"
                                    className="select"
                                    label="Estado (UF)"
                                    id="estado"
                                    value={estadoId ? estadoId.value : ''}
                                    disabled={disabledEstado || loading || hasRecipeDraft}
                                    onChange={estado => (changeEstado(estado))}
                                    options={estadosParaSelecionar || [""]}
                                    isCompact={true}
                                    isSearch={true}
                                    width='270px'
                                    isClearable={!hasRecipeDraft}
                                    selectUniqueOption={false}
                                    loading={loading}
                                    erro={isErroNotRelation}
                                    marginBottom="0px"
                                    // disabled={props.recipeDraft ? true : false}
                                />
                            </div>

                            <div className="selectValue">
                                <SelectV2StepOne
                                    name="agro_culture_id"
                                    className="select"
                                    label="Cultura"
                                    id="cultura"
                                    value={culturaId ? culturaId.value : ''}
                                    disabled={disabledCultura || loading || draftLocksCultura}
                                    onChange={cultura => changeCultura(cultura)}
                                    options={culturas || [""]}
                                    isCompact={true}
                                    isSearch={true}
                                    width='270px'
                                    isClearable={!draftLocksCultura}
                                    selectUniqueOption={false}
                                    loading={loading}
                                    erro={isErroNotRelation}
                                    searchPhoto={true}
                                    onDossie={(op) => openCulturaUrl(op.label)}
                                    marginBottom="0px"
                                />
                            </div>
                        </S.ContainerInputsSelects>
                    </Row>

                    <S.ContainerSelectsAndButtons>
                        {isLoadingRelations === false ? (
                            <>
                                {relations ? (
                                    <>
                                        {relations.map((relationId, index) => (
                                            <>
                                                <RowCard
                                                    isBorder={true}
                                                    key={`relation-${index}`}
                                                    openBox={openRelation[index]}
                                                    erro={hasRecipeDraft
                                                        ? firstIncompleteIndex() === index
                                                        : isErroNotRelation === true || isRelationInvalid(index)}
                                                >
                                                    <S.ContainerInputsAndButtons 
                                                        openRelation={openRelation[index]}
                                                        index={index}
                                                        >
                                                        <S.ContainerImageCard>
                                                            <img className="cancel" alt='cancelar' onClick={() => deleteRelation(index)} src={cancelaIcon} />
                                                        </S.ContainerImageCard>

                                                        <S.ContainerInputsSelect >
                                                            <div className="selectValue">
                                                                <SelectV2StepOne
                                                                    name="agro_product_id"
                                                                    className="select"
                                                                    label="Produto"
                                                                    id={`produto-${index}`}
                                                                    value={typeof produtosId[index] === 'object' ? produtosId[index][0].value : produtosId[index]}
                                                                    disabled={disabledProduto || loading || isLocked(index) || hasRecipeDraft}
                                                                    isClearable={!hasRecipeDraft}
                                                                    onChange={produto => changeProductOnRelation(produto, index)}
                                                                    options={produtos[index] || [""]}
                                                                    isCompact={true}
                                                                    isSearch={true}
                                                                    width='270px'
                                                                    selectUniqueOption={false}
                                                                    isArrow={true}
                                                                    loading={disabledProduto || loading}
                                                                    erro={isErroNotRelation}
                                                                    solicitar={true}
                                                                    marginBottom="0px"
                                                                />
                                                            </div>

                                                            <div className="selectValue">
                                                                <SelectV2StepOne
                                                                    name="agro_pest_id"
                                                                    className="select"
                                                                    label="Praga/Alvo"
                                                                    id={`praga-${index}`}
                                                                    value={typeof pragasId[index] === 'object' ? pragasId[index][0].value : pragasId[index]}
                                                                    disabled={disabledPraga || loading || isLocked(index)}
                                                                    isClearable={true}
                                                                    onChange={praga => changePestOnRelation(praga, index)}
                                                                    options={pragas[index] || [""]}
                                                                    isCompact={true}
                                                                    isSearch={true}
                                                                    width='270px'
                                                                    selectUniqueOption={false}
                                                                    loading={loading}
                                                                    erro={isErroNotRelation}
                                                                    searchPhoto={true}
                                                                    highlightScientificName
                                                                    onDossie={(op) => { setDossie({ id: op.value, name: op.label }); setDossieOpen(true); }}
                                                                    marginBottom="0px"
                                                                    onClick={() => handleOpenPestSelect(index)}
                                                                />
                                                            </div>
                                                        </S.ContainerInputsSelect>

                                                        {loadingRelationAt[index] ? (
                                                            <S.ContainerImageCard>
                                                                <Loading size="18px" style={{ margin: 0 }} />
                                                            </S.ContainerImageCard>
                                                        ) : isRelationComplete(index) ? (
                                                            <S.ContainerImageCard openBox={openRelation[index]}>
                                                                <img className="checked" src={CheckGreenIcon} alt='arrow' onClick={() => openBoxRelation(index, 11)} />
                                                            </S.ContainerImageCard>
                                                        ) : (
                                                            <S.ContainerImageCard openBox={openRelation[index]}>
                                                                <img className="arrow" src={ArrowIcon} alt='arrow' onClick={() => openBoxRelation(index, 11)} />
                                                            </S.ContainerImageCard>
                                                        )}
                                                    </S.ContainerInputsAndButtons>

                                                    {existDispensedProduct && dispensedIndex === index ? (
                                                        <Dispensed> Produto dispensado de receituário </Dispensed>
                                                    ) : (
                                                        <>
                                                            {openRelation[index] ? (
                                                                <ContainerRelationOptions>
                                                                    <Relation
                                                                        index={index}
                                                                        date={saveDate}
                                                                        relation={relations[index]}
                                                                        relationInfo={relationsInfoArray[index]}
                                                                        updateRelationInfo={(relationInfo) => saveRelationInfo(relationInfo, index)}
                                                                        updateRelationId={(id) => changeRelationId(id, index)}
                                                                        isCompendio={isCompendio}
                                                                        compendioParams={isCompendio ? compendioParams[index] : ''}
                                                                        estado={estadoId}
                                                                        compendioLoading={loadingCompendio}
                                                                        recipeDraft={props.recipeDraft}
                                                                        onLoadingChange={(v) => setRelationLoading(index, v)}
                                                                    />
                                                                </ContainerRelationOptions>
                                                            ) : (null)}
                                                        </>
                                                    )}
                                                </RowCard>
                                            </>
                                        ))}
                                    </>
                                ) : (null)}
                            </>
                        ) : (
                            <h3 style={{
                                width: '100%',
                                height: '70px',
                                textAlign: 'center',
                                fontSize: '14px',
                            }}>Removendo relação...</h3>
                        )}

                        <S.ButtonAddNewProduct 
                            onClick={() => hasRecipeDraft ? null : addNewRelation()} 
                            // style={{
                            //     cursor: !loading && !disabledEstado && !disabledCultura && !disabledPraga && !disabledProduto ? 'not-allowed' : 'context-menu',
                            // }}
                            >
                            <img src={hasRecipeDraft ? PlusGrayIcon : PlusBlueIcon} alt="Adicionar"/>

                            <TaglineMSpan cursor="pointer" color={hasRecipeDraft ? theme.colors.disabled.Desabilitado_Medio : theme.colors.blue.Azul_link}>
                                Adicionar outro produto
                            </TaglineMSpan>
                        </S.ButtonAddNewProduct>

                        {props.maxRelations && (estadoId.label !== "" && estadoId.label !== undefined) ? (
                            <S.ContainerInfoRevenuesByStates>
                                <TaglineG color={theme.colors.gray.Cinza_2}>
                                    Até <b>{props.maxRelations} produtos</b> por receita para <b>{estadoId.label}</b>
                                </TaglineG>
                            </S.ContainerInfoRevenuesByStates>
                        ) : (null)}
                    </S.ContainerSelectsAndButtons>
                </Card>
            </FormContainer>

            <PragaDossieDrawer
                pestId={dossie.id}
                pestName={dossie.name}
                isOpen={dossieOpen}
                onClose={() => setDossieOpen(false)}
            />

            <Modal
                show={showModalHelp}
                onHide={() => setShowModalHelp(false)}
                size='md'
            >
                <div>
                    <h4 style={{
                        width: '100%',
                        textAlign: 'center'
                    }}>Dúvidas na emissão da sua receita?</h4>
                    <div>
                        <p style={{
                            width: '100%',
                            textAlign: 'center'
                        }}><a href='https://www.agroreceita.com.br/como-emitir-seu-receituario-agronomico' target='_blank'>Clique aqui</a>  e acesse o tutorial. </p>
                    </div>
                </div >
            </Modal>

        </Container>
    );
};

export default PrescriptionStepOne;
